(function () {
  "use strict";

  const VERSION = "0.4.0";

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function buildGuestHtml(urls) {
    return `
      <div class="qb-orders qb-orders--guest">
        <p class="qb-orders__message">Sign in to view your past orders.</p>
        <a class="qb-account__btn" href="${escapeHtml(window.QB?.loginUrl?.("orders") || urls.login)}">Sign in</a>
      </div>
    `;
  }

  function buildLoadingHtml() {
    return `
      <div class="qb-orders qb-orders--loading" aria-live="polite">
        <p class="qb-slot__loading">Loading orders…</p>
      </div>
    `;
  }

  function buildErrorHtml(message) {
    return `
      <div class="qb-orders qb-orders--error" role="alert">
        <p class="qb-slot__error">${escapeHtml(message)}</p>
        <button type="button" class="qb-account__btn qb-account__btn--secondary" data-qb-retry>Try again</button>
      </div>
    `;
  }

  function buildOrderThumb(order) {
    if (order.image) {
      return `<img class="qb-orders__thumb-img" src="${escapeHtml(order.image)}" alt="" width="56" height="56" loading="lazy">`;
    }
    return `<div class="qb-orders__thumb-placeholder" aria-hidden="true"></div>`;
  }

  function buildOrdersHtml(orders) {
    const { orderStatusLabel, orderItemLabel } = window.QB?.customerData || {};

    if (!orders.length) {
      return `
        <div class="qb-orders">
          <h3 class="qb-orders__title">Past orders</h3>
          <p class="qb-orders__empty">You have no orders yet.</p>
        </div>
      `;
    }

    const rows = orders
      .map((order) => {
        const status = orderStatusLabel ? orderStatusLabel(order) : "Order";
        const items = orderItemLabel ? orderItemLabel(order.itemCount) : "";
        const url = order.url || "#";
        return `
          <a class="qb-orders__row" href="${escapeHtml(url)}">
            <div class="qb-orders__thumb">${buildOrderThumb(order)}</div>
            <div class="qb-orders__meta">
              <p class="qb-orders__status">${escapeHtml(status)}</p>
              <p class="qb-orders__name">${escapeHtml(order.name || "")}</p>
              <p class="qb-orders__items">${escapeHtml(items)}</p>
            </div>
            <span class="qb-orders__chevron" aria-hidden="true">›</span>
          </a>
        `;
      })
      .join("");

    return `
      <div class="qb-orders">
        <h3 class="qb-orders__title">Past orders</h3>
        <div class="qb-orders__list">${rows}</div>
      </div>
    `;
  }

  class QBOrdersSlot {
    constructor(panel) {
      this.panel = panel;
      this.loaded = false;
      this.loading = false;
      this.urls = window.QB?.customerData?.getAccountUrls?.() || { login: "/account/login" };
      this.renderShell();
    }

    renderShell() {
      const customer = window.QB?.customer;
      if (!customer?.loggedIn) {
        this.panel.innerHTML = buildGuestHtml(this.urls);
        return;
      }
      this.panel.innerHTML = buildLoadingHtml();
    }

    bindRetry() {
      this.panel.querySelector("[data-qb-retry]")?.addEventListener("click", () => {
        this.loaded = false;
        window.QB?.customerData?.clearCache?.();
        this.onActivate();
      });
    }

    async onActivate() {
      if (!window.QB?.customer?.loggedIn) return;
      if (this.loaded || this.loading) return;

      this.loading = true;
      this.panel.innerHTML = buildLoadingHtml();

      try {
        const fetchFn = window.QB?.customerData?.fetch;
        if (!fetchFn) throw new Error("customer_data_module_missing");
        const data = await fetchFn();
        this.panel.innerHTML = buildOrdersHtml(data.orders || []);
        this.loaded = true;
      } catch {
        this.panel.innerHTML = buildErrorHtml("Could not load orders. Please try again.");
        this.bindRetry();
      } finally {
        this.loading = false;
      }
    }
  }

  window.QB = window.QB || {};
  window.QB.slotModules = window.QB.slotModules || {};
  window.QB.slotModules.orders = {
    version: VERSION,
    init(panel) {
      return new QBOrdersSlot(panel);
    },
  };
})();
